import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import EmptyBoxLogo from "../../assets/images/inbox-empty.png";
import GlobalEmptyPage from "../../common/GlobalEmptyPage/GlobalEmptyPage";
import TableLoaderSkeleton from "../../global/Loader/TableLoaderSkeleton";
import GlobalTablePagination from "../../global/Pagination/GlobalTablePagination";
import HOCJobPostList from "./HOCJobPostList";
import JobDetails from "./JobDetails";
import JobsMenuAction from "./JobsMenuAction";

const headCells = [
  {
    id: "Job Details",
    label: "Job Details",
  },
  {
    id: "Company name",
    label: "Company Name",
  },
  {
    id: "Publish Date",
    label: "Publish Date",
  },
  {
    id: "Total Candidate",
    label: "Total Candidate",
  },
  {
    id: "Job Actions",
    label: "Job Actions",
  },
];

const JobPostListTable = ({ data: jobPostList = [], isLoading = false, page = 1, perPage = 10, count = 0, onChangePage, onChangePerPage, updatedPublishStatusId, handleChangePublishStatus }) => {
  // decide what to render
  let content = null;
  if (isLoading) {
    content = <TableLoaderSkeleton columns={7} numberOfRows={10} />;
  } else if (jobPostList?.length === 0) {
    content = <GlobalEmptyPage image={EmptyBoxLogo} title={"No Job Post found!"} />;
  } else if (jobPostList?.length > 0) {
    content = (
      <>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} variant={"bordered"}>
            <TableHead>
              <TableRow>
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id} align="left" padding={"normal"}>
                    {headCell.label} 
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {jobPostList.map((jobPost) => {
                const { id, publishDate, companyInfo, totalApplyCandidate } = jobPost || {};
                const { name: companyName } = companyInfo || {};
                const formattedPublishDate = publishDate ? format(new Date(publishDate), "MMM dd, yyyy") : "-";
                return (
                  <TableRow key={id} hover>
                    <TableCell align="left">
                      <JobDetails jobPost={jobPost} />
                    </TableCell>
                    <TableCell align="left">
                      <a rel="noreferrer" target={"_blank"} href={companyInfo?.website}>
                        <Typography variant={"body1"} title={companyName} className={"text-truncate"} sx={{ width: 150 }}>
                          {companyName}
                        </Typography>
                      </a>
                    </TableCell>
                    <TableCell align="left">{formattedPublishDate}</TableCell>
                    <TableCell align="left">{totalApplyCandidate}</TableCell>
                    <TableCell align="left">
                      <JobsMenuAction jobPost={jobPost} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <GlobalTablePagination count={count} page={page} rowsPerPage={perPage} onChangePage={onChangePage} onChangePerPage={onChangePerPage} />
      </>
    );
  }
  return content;
};
export default HOCJobPostList(JobPostListTable);
